import getInObject from '@insight/toolkit-utils/lib/helpers/getInObject';
import shallowEqual from '@insight/toolkit-utils/lib/helpers/shallowEqual';

import { hasAnyError } from './utils';

const publishFormState = (state) => {
  const { fields, formState, lastFormState } = state;
  const fieldKeys = Object.keys(fields);

  let foundDirty = false;
  const { dirtyFields, touched, visited } = fieldKeys.reduce(
    (result, key) => {
      const dirty = !fields[key].isEqual(
        getInObject(formState.values, key),
        getInObject(formState.initialValues || {}, key)
      );
      if (dirty) {
        foundDirty = true;
        result.dirtyFields[key] = true;
      }
      result.touched[key] = fields[key].touched;
      result.visited[key] = fields[key].visited;
      return result;
    },
    { dirtyFields: {}, touched: {}, visited: {} }
  );

  formState.pristine = !foundDirty;
  formState.dirtySinceLastSubmit = !!(
    formState.lastSubmittedValues &&
    !fieldKeys.every((key) =>
      fields[key].isEqual(
        getInObject(formState.values, key),
        getInObject(formState.lastSubmittedValues, key)
      )
    )
  );

  formState.valid =
    !formState.error &&
    !formState.submitError &&
    !hasAnyError(formState.errors) &&
    !(formState.submitErrors && hasAnyError(formState.submitErrors));

  const nextFormState = convertToExternalState(formState);
  nextFormState.dirtyFields =
    lastFormState && shallowEqual(lastFormState.dirtyFields, dirtyFields)
      ? lastFormState.dirtyFields
      : dirtyFields;
  nextFormState.touched =
    lastFormState && shallowEqual(lastFormState.touched, touched)
      ? lastFormState.touched
      : touched;
  nextFormState.visited =
    lastFormState && shallowEqual(lastFormState.visited, visited)
      ? lastFormState.visited
      : visited;

  return lastFormState && shallowEqual(lastFormState, nextFormState)
    ? lastFormState
    : nextFormState;
};

const convertToExternalState = ({
  error,
  errors,
  pristine,
  submitError,
  submitErrors,
  valid,
  validating,
  ...rest
}) => ({
  ...rest,
  dirty: !pristine,
  hasSubmitErrors: !!(
    submitError ||
    (submitErrors && hasAnyError(submitErrors))
  ),
  hasValidationErrors: !!(error || hasAnyError(errors)),
  invalid: !valid,
  pristine,
  validating: validating > 0,
});

export default publishFormState;
